import {IRequestCommand} from 'app/services/authentication/connection/iRequestCommand';
import {ErrorDetails} from 'app/services/authentication/connection/interfaces/apiInterfaces';
import {CommandRequestType} from 'app/services/authentication/connection/commandRequestType';
import {ICommandResponse} from 'app/services/authentication/connection/iCommandResponse';

export class PutEmailTemplateCommand extends IRequestCommand<
  IPutEmailTemplateCommandResponse,
  ErrorDetails,
  IPutEmailTemplateCommandParameters> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;
  override _commandUrl = "contractor/{contractorId}/emailsTemplates"

  public override setParameters(parameters: IPutEmailTemplateCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{contractorId}',
      parameters.contractorId ? parameters.contractorId.toString() : ''
    );
    this._commandBody = parameters;
  }
}

export interface IPutEmailTemplateCommandParameters {
    contractorId: number,
    id: number,
    userId: number,
    html: string,
    logoPlacement: string,
    languageCode: string,
    userType: string
}

export interface IPutEmailTemplateCommandResponse extends ICommandResponse {
}
